import React from 'react';
import { Button } from '../ui/Button';
export function Footer() {
  return <footer className="bg-stone-900 text-white py-16" data-id="element-65">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-66">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 font-serif text-amber-500" data-id="element-67">
          Stop Fighting Your Body. Start Working With It.
        </h2>

        <p className="text-xl text-stone-300 mb-10 max-w-2xl mx-auto" data-id="element-68">
          Join thousands of women who have replaced the "bloat" with "glow."
        </p>

        <div className="mb-16" data-id="element-69">
          <Button size="xl" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="shadow-amber-900/50" data-id="element-70">
            BUY NOW FOR $27
          </Button>
        </div>

        <div className="border-t border-stone-800 pt-8 text-stone-500 text-sm" data-id="element-71">
          <div className="flex flex-col md:flex-row justify-center gap-6 mb-4" data-id="element-72">
            <a href="#" className="hover:text-amber-500 transition-colors" data-id="element-73">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-amber-500 transition-colors" data-id="element-74">
              Terms of Service
            </a>
            <a href="#" className="hover:text-amber-500 transition-colors" data-id="element-75">
              Contact Support
            </a>
          </div>
          <p data-id="element-76">
            © {new Date().getFullYear()} The Golden Root Ritual. All rights
            reserved.
          </p>
          <p className="mt-2 text-xs max-w-2xl mx-auto" data-id="element-77">
            Disclaimer: The content of this site is for informational purposes
            only, and is not intended to replace professional medical advice,
            diagnosis or treatment. Always seek the advice of your physician or
            other qualified health provider with any questions you may have
            regarding a medical condition.
          </p>
        </div>
      </div>
    </footer>;
}